import { TREATYLIMIT_INIT_SUCCESS, TREATYLIMIT_INIT_FAIL, TREATYLIMIT_INIT_LOADING, TREATYLIMIT_COMMIT_KEY } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {},
  treatyLimit: {
    treatyLimitId: {
      treatyMode: null,
      accmType: null,
      treatyNo: null,
      riType: null,
      effDate: null,
      treatyLvl: null,
      facVal1: null,
      facVal2: null,
      facVal3: null,
      facVal4: null,
      facVal5: null,
      facVal6: null,
      limType: null,
      accountNoSuffix: null
    }
  }
}

const getters = {
}

const mutations = {
  [TREATYLIMIT_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [TREATYLIMIT_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.initErr = []
  },
  [TREATYLIMIT_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [TREATYLIMIT_COMMIT_KEY](state, data) {
    state.treatyLimit.treatyLimitId.accmType = data.accmType
    state.treatyLimit.treatyLimitId.treatyMode = data.treatyMode
    state.treatyLimit.treatyLimitId.treatyNo = data.treatyNo
    state.treatyLimit.treatyLimitId.riType = data.riType
    state.treatyLimit.treatyLimitId.effDate = data.effDate
    state.treatyLimit.treatyLimitId.treatyLvl = data.treatyLvl
    state.treatyLimit.treatyLimitId.facVal1 = data.facVal1
    state.treatyLimit.treatyLimitId.facVal2 = data.facVal2
    state.treatyLimit.treatyLimitId.facVal3 = data.facVal3
    state.treatyLimit.treatyLimitId.facVal4 = data.facVal4
    state.treatyLimit.treatyLimitId.facVal5 = data.facVal5
    state.treatyLimit.treatyLimitId.facVal6 = data.facVal6
    state.treatyLimit.treatyLimitId.limType = data.limType
    state.treatyLimit.treatyLimitId.accountNoSuffix = data.accountNoSuffix
  }
}

const actions = {
  async treatyLimitManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.treatyLimitManagement
    commit(TREATYLIMIT_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(TREATYLIMIT_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(TREATYLIMIT_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
